import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { EMAIL_NOT_FOUND } from '../../../../constants/ErrorTypes';
import { accountResetPassword } from '../../../../actions/authenticationActions';
import EmailResetLinkForm from './EmailResetLinkForm';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_PASSWORD,
	EVT_RECOVER_PASSWORD_START,
	EVT_ELEMENT_INTERACTION,
	EVT_ELEMENT_NAME_PASSWORD_RECOVERY,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_SEND_EMAIL,
	EVT_ELEMENT_STYLE_PRIMARY,
} from '../../../../constants/SnowplowEvents';
import { ONBOARDING_FORGOT_PASSWORD_CTA } from '../../../../constants/Copy';

@connect(
	(state) => {
		const accountOwnerId = _.get(state, 'profiles.accountOwnerId');
		const accountOwnerEmail = accountOwnerId
			? _.get(state, `profiles.all.${accountOwnerId}.email`)
			: null;
		return {
			initialValues: {
				email: accountOwnerEmail || state.authentication.email,
			},
		};
	},
	{ accountResetPassword }
)
export default class EmailResetLink extends Component {
	handleSubmit = ({ email }) => {
		initiateTrackStructEvent({
			category: EVT_PASSWORD,
			action: EVT_RECOVER_PASSWORD_START,
			label: ONBOARDING_FORGOT_PASSWORD_CTA,

			rtlElementContext: {
				elementInteraction: EVT_ELEMENT_INTERACTION,
				elementGroup: EVT_ELEMENT_NAME_PASSWORD_RECOVERY,
				elementType: EVT_ELEMENT_TYPE_BUTTON,
				elementName: EVT_SEND_EMAIL,
				elementLabel: ONBOARDING_FORGOT_PASSWORD_CTA,
				elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
			},
		});
		return this.props.accountResetPassword(email).catch((err) => {
			if (err.message === EMAIL_NOT_FOUND) {
				throw new SubmissionError({ email: err.message });
			}
		});
	};

	render() {
		const { initialValues } = this.props;
		return <EmailResetLinkForm initialValues={initialValues} onSubmit={this.handleSubmit} />;
	}
}
